// extracted by mini-css-extract-plugin
export default {"container":"FeatureInfo_container__vKbt7","mainCard":"FeatureInfo_mainCard__zw5eN","stack":"FeatureInfo_stack__UMk-j","stackCard":"FeatureInfo_stackCard__7rw5l"};